export const getCurrentWindowWidth = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return 768;
  const width = Math.max(document?.documentElement.clientWidth, window?.innerWidth || 0);
  return width;
};

export const getCurrentWindowHeight = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return 1024;
  const height = Math.max(document?.documentElement.clientHeight, window?.innerHeight || 0);
  return height;
};

export const isMobile = () => {
  try {
    const isMob = getCurrentWindowWidth() < 768;
    return isMob;
  } catch (err) {
    console.error('IsMobile Error', err);
    return false;
  }
};

export const isMobileOrTablet = () => {
  try {
    const isMobOrTab = getCurrentWindowWidth() < 1024;
    return isMobOrTab;
  } catch (err) {
    console.error('IsMobileORTAb Error', err);
    return false;
  }
};
